/* Verticais de Mercado — barra de progresso sob a aba ativa.
   A troca de aba/painel em si é o <tabs-element> nativo do tema
   (assets/theme.js): ele já cuida de role="tab", transição suave dos
   painéis e do estado button--primary/button--secondary.
   Aqui só: posicionar a trilha sob a aba ativa e, com autoplay ligado,
   animar o preenchimento de 0 a 100% (Web Animations API, sem bounce) —
   ao completar, avança para a próxima aba, igual à lógica de autoplay
   do Camadas (slider): pausa no hover/foco e quando a aba do navegador
   fica em segundo plano. */
(function () {
  function setup(root) {
    var tabsEl = root.querySelector('tabs-element') || root;
    var tabsWrap = root.querySelector('.vm-tabs');
    var track = root.querySelector('[data-vm-indicator]');
    var fill = track ? track.querySelector('[data-vm-indicator-fill]') : null;
    var buttons = Array.from(tabsEl.querySelectorAll('button[role="tab"]'));
    if (!track || !fill || buttons.length === 0) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayEnabled = tabsEl.hasAttribute('data-autoplay') && buttons.length > 1 && !reducedMotion;
    var duration = (parseFloat(tabsEl.getAttribute('data-autoplay-speed')) || 6) * 1000;
    var anim = null;

    function currentIndex() {
      return parseInt(tabsEl.getAttribute('selected-index'), 10) || 0;
    }

    function positionTrack(index) {
      var tab = buttons[index];
      if (!tab) return;
      track.style.width = tab.offsetWidth + 'px';
      track.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
    }

    // A barra de abas rola na horizontal no mobile (várias verticais não
    // cabem na tela) — sem isso, uma aba ativada por autoplay ou clique
    // pode ficar parcialmente fora da área visível.
    function scrollTabIntoView(index) {
      var tab = buttons[index];
      if (!tab || !tabsWrap) return;
      var target = tab.offsetLeft - (tabsWrap.clientWidth - tab.offsetWidth) / 2;
      var max = tabsWrap.scrollWidth - tabsWrap.clientWidth;
      target = Math.max(0, Math.min(max, target));
      tabsWrap.scrollTo({ left: target, behavior: reducedMotion ? 'instant' : 'smooth' });
    }

    function advance() {
      tabsEl.selectedIndex = (currentIndex() + 1) % buttons.length;
    }

    function startFill(index) {
      if (anim) anim.cancel();
      positionTrack(index);
      scrollTabIntoView(index);

      if (!autoplayEnabled) {
        fill.style.transform = 'scaleX(1)';
        return;
      }

      fill.style.transform = 'scaleX(0)';
      anim = fill.animate(
        [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
        { duration: duration, easing: 'linear', fill: 'forwards' }
      );
      anim.finished
        .then(advance)
        .catch(function () { /* cancelada por clique manual — nada a fazer */ });
    }

    new MutationObserver(function () {
      startFill(currentIndex());
    }).observe(tabsEl, { attributes: true, attributeFilter: ['selected-index'] });

    if (autoplayEnabled) {
      ['pointerenter', 'focusin'].forEach(function (evt) {
        root.addEventListener(evt, function () { if (anim) anim.pause(); });
      });
      ['pointerleave', 'focusout'].forEach(function (evt) {
        root.addEventListener(evt, function () { if (anim) anim.play(); });
      });
      document.addEventListener('visibilitychange', function () {
        if (!anim) return;
        if (document.hidden) anim.pause();
        else anim.play();
      });
    }

    window.addEventListener('resize', function () {
      positionTrack(currentIndex());
    });

    startFill(currentIndex());
  }

  document.querySelectorAll('[data-vm-tabs]').forEach(setup);
})();
